import React, { ReactChild, ReactChildren, ReactElement } from 'react';
import Navbar from './Navbar';
import '../styles/global.css';

interface LayoutProp {
  children: ReactChild | ReactChild[] | ReactChildren | ReactChildren[];
}

export default function Layout({ children }: LayoutProp): ReactElement {
  return (
    <div className="layout">
      <Navbar />
      <div className="content">{children}</div>
      <footer>
        <p>Copyright 2021 Tim Wu</p>
      </footer>
    </div>
  );
}
